import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { DatabaseContainerLoader } from '@confluence/confluence-databases/entry-points/DatabaseContainerLoader.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { fg } from '@confluence/feature-gating';

import SpaceRestriction from '../../SpaceBase/SpaceRestriction.js';
import { LazyDwellTime, LazyConsumptionViewedAndCompletedEventTracker } from '../lazyComponents.js';

export const DatabaseViewRoute = ({ params: { contentId, spaceKey } }: RouteMatch) =>
	fg('confluence-fix-space-db-redirect-behaviour') ? (
		<SpaceRestriction spaceKey={spaceKey} contentId={contentId}>
			<DatabaseContainerLoader contentId={contentId} spaceKey={spaceKey} />
			<LazyDwellTime />
			<LazyConsumptionViewedAndCompletedEventTracker
				spaceKey={spaceKey}
				source="DatabaseViewRoute"
			/>
		</SpaceRestriction>
	) : (
		<SpaceRestriction spaceKey={spaceKey}>
			<DatabaseContainerLoader contentId={contentId} spaceKey={spaceKey} />
			<LazyDwellTime />
			<LazyConsumptionViewedAndCompletedEventTracker
				spaceKey={spaceKey}
				source="DatabaseViewRoute"
			/>
		</SpaceRestriction>
	);

DatabaseViewRoute.NAVIGATION_PARAMS = ({
	name: routeName,
	params: { contentId, spaceKey },
}: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'databaseScreen',
			id: contentId,
			attributes: {
				contentId,
			},
		},
		pageState: {
			contentId,
			spaceKey,
			contentType: 'database',
			routeName,
		},
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
		isViewPage: true,
	},
});
